import { fechFromBPartsApi } from '../utils';

export const fetchCurrencies = ({
  locale,
}: {
  locale: string;
}): Promise<Currencies> =>
  fechFromBPartsApi(`/${locale}/shop/currencies`, {
    credentials: 'include',
  }).then((value) => value.json());
